import { WOODEN_FLOORS } from '@/constants/accessor/api/emergencyInspectionResult/assessmentDetails/step2/woodenFloors'

/** 階段(木造) */
/** labels */
export const woodenFloorsOption = [
  { value: WOODEN_FLOORS.UNSELECTED, text: '未選択' },
  { value: WOODEN_FLOORS.ONE, text: '平屋' },
  { value: WOODEN_FLOORS.TWO, text: '2階建て' },
  { value: WOODEN_FLOORS.OTHER, text: 'その他' }
] as const
